// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"740":"fa6ece9d","944":"4cde76cf"}[chunkId] + ".chunk.js";
};